<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        自定义考核内容
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            title="新增"
            icon="el-icon-plus"
            @click="$router.push('/customSelfAssessmentFromAdd')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.bookingDate">
            <el-date-picker
              v-model="slotForms.forms.selfDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择年"
              @change="handleSelYear"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.appraisalName">
            <el-select
              v-model="slotForms.forms.appraisalName"
              clearable
              placeholder="自评表名称"
            >
              <el-option
                v-for="item in appraisalList"
                :key="item.appraisalName"
                :label="item.appraisalName"
                :value="item.appraisalName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.appraisalStatus">
            <el-select
              v-model="slotForms.forms.appraisalStatus"
              clearable
              placeholder="表单状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <template v-for="(item, index) in localShowTableCols">
          <el-table-column
            :key="index"
            :label="item.title"
            align="center"
            :show-overflow-tooltip="true"
            v-if="item.name == 'appraisalStatus'"
          >
            <template slot-scope="{ row }">
              {{
                row[item.name] == 0
                  ? "草稿"
                  : row[item.name] == 1
                  ? "已发起"
                  : "已截止"
              }}
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.title"
            align="center"
            :show-overflow-tooltip="true"
            v-else-if="item.name == 'file'"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="downloadPdf(row)">下载</el-button>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.title"
            align="center"
            :show-overflow-tooltip="true"
            v-else-if="item.name == 'deliver'"
          >
            <template slot-scope="{ row }">
              <div v-if="!row[item.name]">--</div>
              <div
                v-else
                @click="getSubmitDetail(row)"
                :class="
                  row[item.name].split('/')[0] == row[item.name].split('/')[1]
                    ? 'cBlue'
                    : 'cRed'
                "
              >
                {{ row[item.name] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :show-overflow-tooltip="true"
            min-width="150"
            align="center"
            :prop="item.name"
            :label="item.title"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" align="center" label="操作" width="160">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.详情"
              :to="{
                path: '/customSelfAssessmentFromDetail',
                query: {
                  appraisalSelfId: scope.row.appraisalSelfId,
                },
              }"
              >详情</router-link
            >&nbsp;

            <el-button
              v-if="
                operationSuper.编辑 &&
                (scope.row.appraisalStatus == 0 ||
                  scope.row.appraisalStatus == 1)
              "
              @click="handleEdit(scope.row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            &nbsp;
            <el-button
              v-if="scope.row.appraisalStatus != 0"
              @click="setAppraisalForm(scope.row)"
              type="text"
              size="small"
              >{{
                scope.row.appraisalStatus == 1 ? "停止填写" : "启用填写"
              }}</el-button
            >
            <el-button
              v-if="operationSuper.删除 && scope.row.appraisalStatus == 0"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <!-- 企业提交详情弹框 -->
    <el-dialog title="企业提交详情" :visible.sync="dialogVisible" width="500px">
      <div>
        <p>未提交企业：({{ companySubmitDetail.notCommit.length }})</p>
        <span v-for="(v, i) in companySubmitDetail.notCommit" :key="i">
          <span v-if="i != companySubmitDetail.notCommit.length - 1">
            {{ `${v.companyName}、` }}
          </span>
          <span v-else> {{ v.companyName }}</span>
        </span>
      </div>
      <div class="mt40">
        <p>已提交企业：({{ companySubmitDetail.alreadyCommit.length }})</p>
        <span v-for="(v, i) in companySubmitDetail.alreadyCommit" :key="i">
          <span v-if="i != companySubmitDetail.alreadyCommit.length - 1">
            {{ `${v.companyName}、` }}
          </span>
          <span v-else> {{ v.companyName }}</span>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteAppraisalForm,
  setAppraisalFormStatus,
  getFormNameList,
  getCorpSubmitDetail,
} from "@/api/businessApplication";
import { mapActions } from "vuex";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import moment from "moment";
export default {
  mixins: [operationManage, listInit],
  data() {
    return {
      // dataType: "object",
      isSearch: false,
      formExtend: {
        forms: {
          selfDate: moment().format("YYYY"), // 自评年份
          appraisalName: "", // 自评表名称
          appraisalStatus: "", // 自评表状态
        },
        extends: [],
      },
      statusOptions: [
        {
          value: 0,
          label: "草稿",
        },
        {
          value: 1,
          label: "已发起",
        },
        {
          value: 2,
          label: "已截止",
        },
      ],
      appraisalList: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      isFirstLoad: true,
      // 请求表格数据
      tableDataUrl: "/appraisal/self/list",
      //导出URL
      exportUrl: "/appraisal/self/export?",
      // 企业提交详情弹框
      dialogVisible: false,
      companySubmitDetail: {
        alreadyCommit: [],
        notCommit: [],
      },
    };
  },

  created() {
    this.setSearchFormIsOpenAct();
    this.getFormNameByYear();
    this.initPage();
  },
  mounted() {},
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 根据申请年份查询自评表名称
    async getFormNameByYear() {
      try {
        let res = await getFormNameList({
          selfDate: this.formExtend.forms.selfDate,
        });
        if (res.code) {
          this.appraisalList = res.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //
    handleSelYear() {
      this.getFormNameByYear();
      this.formExtend.forms.appraisalName = "";
    },
    // 点击编辑
    handleEdit({ appraisalStatus, appraisalSelfId }) {
      this.$router.push({
        path: "/customSelfAssessmentFromEdit",
        query: {
          appraisalSelfId: appraisalSelfId,
          appraisalStatus: appraisalStatus,
        },
      });
    },
    // 点击查询企业提交详情
    async getSubmitDetail({ appraisalSelfId }) {
      try {
        let res = await getCorpSubmitDetail({
          appraisalSelfId: appraisalSelfId,
        });
        if (res.code) {
          this.companySubmitDetail = res.result;
          this.dialogVisible = true;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 重置
    handleResetForm() {
      this.formExtend.forms.selfDate = moment().format("YYYY"); // 自评年份
    },
    // 下载pdf
    async downloadPdf({ appraisalSelfId }) {
      try {
        window.open(
          `/appraisal/self/download?appraisalSelfId=${appraisalSelfId}`,
          "_blank"
        );
      } catch (err) {
        console.log(err);
      }
    },

    // 删除行
    deleteRow({ row }) {
      this.$confirm("确定删除自评表?", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await deleteAppraisalForm({
            appraisalSelfId: row.appraisalSelfId,
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
              this.initVehicleTree();
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {});
    },
    // 停止与启用
    setAppraisalForm({ appraisalStatus, appraisalSelfId }) {
      this.$confirm(
        `${
          appraisalStatus == 1
            ? "确定停止填写自评表，停止后表单将不可填写及提交？"
            : "确定启用填写自评表，启用后表单将可填写及提交？"
        }`,
        `${appraisalStatus == 1 ? "停止填写" : "启用填写"}`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          this.tableLoading = true;
          const { code, message } = await setAppraisalFormStatus({
            appraisalSelfId: appraisalSelfId,
            appraisalStatus: appraisalStatus == 1 ? 2 : 1,
          });
          this.tableLoading = false;
          if (code === 1) {
            this.$message.success("提交成功");
            this.handleCurrentChange(1);
            this.initVehicleTree();
          } else {
            this.errorMessage(message || "提交失败，请重试");
          }
        })
        .catch(() => {});
    },

    // 导出
    handleExportClick() {
      let param = "";
      param += "&selfDate=" + this.formExtend.forms.selfDate;
      param += "&appraisalName=" + this.formExtend.forms.appraisalName;
      param += "&appraisalStatus=" + this.formExtend.forms.appraisalStatus;
      document.location.href = this.exportUrl + param;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.mt40 {
  margin-top: 40px;
}
.cBlue {
  cursor: pointer;
  color: #51b0fe;
}
.cRed {
  cursor: pointer;
  color: red;
}
.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}

/deep/ .e6-from--column-2 .vehicle_temp {
  width: 100px !important;
}
.operate-btn {
  height: 29px;
  color: #fff;
  background: #2f4ef2;
  border-color: #2f4ef2;
  &:hover {
    color: #fff;
    background: #2f4ef2;
    border-color: #2f4ef2;
  }
}
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
    p {
      font-size: 16px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
